import React, { useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const Grid = () => {
    const [showGrid, setShowGrid] = useState(false);

    useEffect(() => {
        const gridKeyHandler = (e) => e.key === 'g' && setShowGrid((v) => !v);
        document.addEventListener('keydown', gridKeyHandler);
        return () => document.removeEventListener('keydown', gridKeyHandler);
    }, []);


    if (showGrid) {
        return (
            <div className='fixed inset-0 z-50 pointer-events-none'>
                <div className='h-screen layout-container flex flex-wrap'>
                    {[...Array(12).keys()].map((col, i) => {
                        return (
                            <div
                                className='w-1/12 px-10 sm:px-5 md:px-10'
                                key={i}>
                                <div className='h-full w-full bg-dark-blue/5 border-x border-x-dark-blue/30' />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    return null;
};

/* ========================================================================= */
/* Typing & export(s) */
/* ========================================================================= */

export default Grid;
